import React from "react";
import { Grid } from "@mui/material";
import { InputField } from "../../../../../library/custom/textBox/InputField";

const DayRainfall = (props) => {
  const rainFallHandler = (value, insRainFallData) => {
    const confRainFallValue = value;

    props?.setSwInspectionRainfallData((prevState) => {
      const existingIndex = prevState.findIndex(
        (item) => item.precipDateFormat === insRainFallData.precipDateFormat
      );
      if (existingIndex !== -1) {
        const updatedData = [...prevState];
        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          day: insRainFallData?.precipDateFormat,
          rainfallAmt: insRainFallData?.evenTrackPrecipAmt,
          notes: confRainFallValue,
        };
        return updatedData;
      }
    });
  };

  const initials = props?.primaryInspector
    ? props?.primaryInspector
        ?.split(" ")
        ?.map((word) => word.charAt(0).toUpperCase())
        ?.join("")
    : "";

  return (
    <>
      <Grid container>
        <Grid item md={12} className="northCarolinaOverride" mt={3}>
          <div className="commonTableBoxNorth">
            <div className="commonTableBoxNorthTitle">7 Day Rainfall Data</div>
            <table>
              <tr className="tableHead">
                <th>Day/Date </th>
                <th>Rain Amount (in)</th>
                <th>Initials</th>
                <th className="fourty">
                  Notes:
                  <div className="smallText">
                    Daily Rainfall Required. Except for Holidays or Weekends.If
                    no rain, indicate with a “zero”
                  </div>
                </th>
              </tr>
              {props?.swRainFallData?.map((rainFall) => {
                const onchangeValue = props?.swInspectionRainfallData.find(
                  (item) => item.precipDateFormat === rainFall.precipDateFormat
                )?.notes;

                return (
                  <tr className="tableBody" key={rainFall?.precipId}>
                    <td>{rainFall?.precipDateFormat || rainFall.day}</td>
                    <td>
                      {(
                        Math.floor(rainFall?.evenTrackPrecipAmt * 100) / 100
                      )?.toFixed(2)}
                    </td>
                    <td>{initials}</td>
                    <td>
                      <InputField
                        isRequired={false}
                        type="text"
                        placeholder={"Enter Here..."}
                        value={onchangeValue}
                        onChange={(e) =>
                          rainFallHandler(e.target.value, rainFall)
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default DayRainfall;
